export default function CloseIcon() {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 10.59l5.66-5.66a1 1 0 111.41 1.41L13.41 12l5.66 5.66a1 1 0 11-1.41 1.41L12 13.41l-5.66 5.66a1 1 0 11-1.41-1.41L10.59 12 4.93 6.34a1 1 0 111.41-1.41L12 10.59z" />
    </svg>
  );
}
